import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { SvgIconProps } from './SvgIcon.types';

export const ClipboardIcon = memo(({ className }: SvgIconProps) => (
  <SvgIcon className={className} viewBox="0 0 25 30">
    <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.607 6.89978H23.9999V28.9999H2.79419V6.89978H6.1871" fill="#F0CBA7" />
      <path
        d="M20.607 6.89978H23.9999V28.9999H2.79419V6.89978H6.1871H20.607Z"
        stroke="#F0CBA7"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3658 6.03327C16.3658 4.35804 15.0366 3 13.397 3C11.7574 3 10.4282 4.35804 10.4282 6.03327H8.30762V9.49987H18.4863V6.03327H16.3658Z"
        fill="#F0CBA7"
        stroke="#F0CBA7"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.63403 15.2998L10.7546 17.4664L14.9957 13.1332"
        stroke="#226937"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8128 4.90002H22.2057V26.9999H1V4.90002H4.39291"
        stroke="#EA7200"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5716 4.03327C14.5716 2.35804 13.2424 1 11.6028 1C9.96317 1 8.634 2.35804 8.634 4.03327H6.51343V7.49987H16.6922V4.03327H14.5716Z"
        stroke="#EA7200"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6029 4.89983C12.0713 4.89983 12.4511 4.51178 12.4511 4.0331C12.4511 3.55443 12.0713 3.16638 11.6029 3.16638C11.1344 3.16638 10.7546 3.55443 10.7546 4.0331C10.7546 4.51178 11.1344 4.89983 11.6029 4.89983Z"
        fill="#226937"
      />
      <path
        d="M19.661 7.49988V24.3997H3.54468V7.49988"
        stroke="#EA7200"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
));
